<template>
  <article
    class="flex flex-col w-full text-white rounded-lg p-3 overflow-hidden h-[12rem]"
    :style="{ background: '#090E23' }"
  >
    <header class="flex justify-between items-start w-full mb-2">
      <div class="flex-1 min-w-0 pr-4">
        <h2 class="text-2xl 2xl:text-3xl font-bold leading-tight tracking-wide truncate">
          {{ props.card.title }}
        </h2>
        <p class="text-white/60 text-sm 2xl:text-base truncate">
          {{ props.card.app }}
        </p>
      </div>
      <div class="flex gap-2 min-w-fit">
        <img 
          :src="props.card.logo ? props.card.logo : '/images/empty-photo.png'" 
          :alt="`${props.card.title} icon`"
          class="h-[38px] w-[38px] min-h-[2rem] min-w-[2rem] max-h-[2.5rem] max-w-[2.5rem] object-contain rounded-md"
          loading="lazy"
        >
               
               
        <img 
          :src="props.card.app_icon ? props.card.app_icon : '/images/empty-photo.png'" 
          :alt="`${props.card.title} icon`"
          class="h-[38px] w-[38px] min-h-[2rem] min-w-[2rem] max-h-[2.5rem] max-w-[2.5rem] object-contain rounded-md"
          loading="lazy"
        >
      </div>
    </header>

    <p class="text-sm italic text-white line-clamp-2 overflow-y-scroll custom-scroll">
      "{{
        props.card.description }}"
    </p>

    <footer class="flex items-center justify-between w-full mt-auto">
      <div class="flex items-center gap-2 shrink-0">
        <div
          v-if="props.card.trending"
          class="rounded-full w-8 h-8 flex items-center justify-center p-1"
          :style="{ background: '#FF540A' }"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="#090E23"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M18.122 17.645a7.185 7.185 0 0 1-2.656 2.495 7.06 7.06 0 0 1-3.52.853 6.617 6.617 0 0 1-3.306-.718 6.73 6.73 0 0 1-2.54-2.266c-2.672-4.57.287-8.846.887-9.668A4.448 4.448 0 0 0 8.07 6.31 4.49 4.49 0 0 0 7.997 4c1.284.965 6.43 3.258 5.525 10.631 1.496-1.136 2.7-3.046 2.846-6.216 1.43 1.061 3.985 5.462 1.754 9.23Z"
            />
          </svg>
        </div>
        <div
          class="rounded-full w-8 h-8 flex items-center justify-center"
          :style="{ background: props.card.category_color }"
        >
          <span 
            class="w-5 h-5 flex items-center justify-center text-[#090E23]" 
            v-html="props.card.category_icon"
          />
        </div>
      </div>
      <div class="shrink-0 text-sm">
        <button
          class="flex items-center justify-center gap-2 font-bold text-gray-600 hover:text-gray-700 rounded-lg bg-gray-200  px-3 py-1.5 hover:bg-gray-100 transition-colors"
          @click="execAction"
        >
          <span class="text-xs 2xl:text-sm ">Launch</span>
          <ArrowCircleRight class="w-4 h-4" />
        </button>
      </div>
    </footer>
  </article>
</template>
<script setup>

import ArrowCircleRight from '@/Icons/ArrowCircleRight.vue';
import { defineProps, defineEmits } from 'vue';

const props = defineProps(['card']);
const emit = defineEmits(['action']);

function execAction() {
    if (props.card.active) {
        emit('action', props.card.action)
    } else {
        alert('Coming soon...')
    }
}

</script>


<style scoped>
.custom-scroll::-webkit-scrollbar {
    display: none;
}

.custom-scroll {
    -ms-overflow-style: none;
    scrollbar-width: none;
}
</style>